module.exports = __webpack_public_path__ + "img/airbase-stage_6.1.9b85be18.jpg";